<template>
  <div id ="imagesViewer"
      @keyup.right="index = index === numberOfImages - 1 ? 0: (index+1)"
      @keyup.left="index = index === 0? numberOfImages - 1 : (index-1)">
    <v-container grid-list-md>
      <v-toolbar color="white" >
        <h2>Visor Images</h2>
        <v-spacer></v-spacer>
        <v-dialog v-model="showAddNewPicture" max-width="500px">
                <v-icon slot="activator" >cloud_upload</v-icon>
                <v-form  v-model="isNewPictureValid" onSubmit="return false;">
                <v-card>
                  <v-card-title primary-title>
                    <h1>Agregar Foto</h1>
                  </v-card-title>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 text-xs-center>
                          <img :src="imageUrl" height="150" v-if="imageUrl"/>
                          <v-text-field label="Selecciona la Imagen" @click='pickFile' v-model='imageName' prepend-icon='attach_file'></v-text-field>
                          <input
                            type="file"
                            style="display: none"
                            ref="image"
                            accept="image/*"
                            @change="onFilePicked"
                          >
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            name="pictureName"
                            label="Nombre Imagen"
                            v-model="newPicture.path"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="showAddNewPicture = false">Cancelar</v-btn>
                    <v-btn color="success" @click="addPicture" :disabled="!isNewPictureValid">Guardar</v-btn>
                  </v-card-actions>
                </v-card>
                </v-form>
              </v-dialog>
      </v-toolbar>
      <v-layout row wrap>
        <v-flex xs12>
          <v-form @submit="updateValues" v-model="valid" ref="updateValuesForm" onSubmit="return false;">
          <v-card>
            <v-card-title primary-title>
              <v-layout row wrap>
                <v-flex xs12>
                  <h3>{{current.path}}</h3>
                </v-flex>
              </v-layout>
            </v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs-1 v-on:click="index = index === 0 ? numberOfImages - 1 : (index-1)">
                  <
                </v-flex>
                <v-flex xs10>
                  <v-layout row wrap>
                    <v-flex xs4>
                      <v-img v-if="image" v-bind:src="image"  height="325"/>
                      <v-img v-else src="/img/img_not_found.png" height="325" contain></v-img>
                    </v-flex>
                    <v-flex xs8>
                      <v-text-field
                        name="CropTop"
                        label="Corte Superior"
                        id="corte-superior"
                        v-model="current.crop_top"
                        ref="cropTop"
                      ></v-text-field>
                      <v-text-field
                        name="CropBottom"
                        label="Corte Inferior"
                        id="corte-inferior"
                        v-model="current.crop_bottom"
                      ></v-text-field>
                      <v-btn type="submit" color="success">Guardar</v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs1 v-on:click="index = index === numberOfImages - 1 ? 0: (index+1)">
                  >
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
          </v-form>
        </v-flex>
        <v-flex xs6>
          <v-card>
            <v-card-title primary-title>
              <v-layout row wrap>
                <v-flex xs11>
                  <h2>Catalizadores Asignados</h2>
                </v-flex>
                <v-flex xs1>
                  <v-dialog v-model="showAssignSerialNumber" max-width="500px">
                    <v-icon slot="activator" >add</v-icon>
                    <v-form  v-model="isSerialNumberValid" onSubmit="return false;">
                    <v-card>
                      <v-card-title primary-title>
                        <h1>Asignar catalizador</h1>
                      </v-card-title>
                      <v-card-text>
                        <v-container grid-list-md>
                          <v-layout wrap>
                            <v-flex xs12>
                              <v-text-field
                                name="cat_serial_number"
                                label="Numero de Serie"
                                v-model="serial_number"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click="showAssignSerialNumber = false">Cancelar</v-btn>
                        <v-btn color="blue-grey darken-2 white--text" @click="addSerialNumber" :disabled="!isSerialNumberValid">Guardar</v-btn>
                      </v-card-actions>
                    </v-card>
                    </v-form>
                  </v-dialog>
                </v-flex>
              </v-layout>
            </v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs6 v-for="sn in relatedSerialNumbers" :key="sn.serial_number">
                  {{sn.serial_number}}
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs6>
          <v-card>
            <v-form @submit="goToIndex" v-model="valid" ref="goToForm" onSubmit="return false;">
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs8>
                    <v-text-field
                      name="index"
                      label="Ir a Imagen"
                      v-model="userIntroducedIndex"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4>
                    <v-btn color="success" @click="goToIndex">Ir</v-btn>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-form>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'Images',
  data() {
    return {
      images: [],
      current: {},
      index: undefined,
      image: '',
      numberOfImages: 0,
      valid: true,
      userIntroducedIndex: 0,
      relatedSerialNumbers: [],

      // Add picture dialog data
      showAddNewPicture: false,
      isNewPictureValid: true,
      newPicture: {},
      imageName: '',
      imageUrl: '',
      imageFile: '',

      // Assign serial number dialog data
      showAssignSerialNumber: false,
      isSerialNumberValid: true,
      serial_number: '',

    };
  },
  watch: {
    async index() {
      this.current = this.images[this.index];
      this.retrieveImageData();
      this.$refs.cropTop.focus();
      this.userIntroducedIndex = this.index;
    },
  },
  methods: {

    goToIndex() {
      this.index = parseInt(this.userIntroducedIndex, 10);
    },
    async retrieveImageData() {
      if (this.images[this.index]) {
        this.image = await this.axios.get(`/img/${this.images[this.index].path}`);
        this.image = this.image.data;
        this.relatedSerialNumbers = await this.axios.get(`/img/${this.images[this.index].path}/relatedSerialNumbers`);
        this.relatedSerialNumbers = this.relatedSerialNumbers.data;
      } else {
        this.$emit('error', `Error al acceder al indice ${this.index}`);
      }
    },
    async updateValues() {
      await this.axios.put('/img/crop', this.current);
      this.retrieveImageData();
    },
    async addPicture() {
      const formData = new FormData();
      formData.append('image', this.imageFile);
      formData.append('pictureName', this.newPicture.path);
      this.axios.post('/img/', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
      }).then( (result) => {
        const obj = this.images.find((o) => o.path === result.data.path);
        if (obj) {
          const index = this.images.indexOf(obj);
        } else {
          this.images.push(result.data);
          this.index = this.images.length - 1;
        }
      });
      this.showAddNewPicture = false;
      this.$emit('success', 'Foto guardada');
    },
    pickFile() {
      this.$refs.image.click();
    },

    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf('.') <= 0) {
          return;
        }
        const fr = new FileReader ();
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', () => {
          this.imageUrl = fr.result;
          this.imageFile = files[0]; // this is an image file that can be sent to server...
        });
      } else {
        this.imageName = '';
        this.imageFile = '';
        this.imageUrl = '';
      }
    },

    addSerialNumber() {
      const updateData = {
        picture_path: this.current.path,
        serial_number: this.serial_number,
      };
      this.axios.put('/catalogs/products/updatePicture', updateData)
        .then ((results) => {
          this.retrieveImageData();
          this.$emit('success',  `Asignada la foto para el catalizador ${this.serial_number}` );
          this.showAssignSerialNumber = false;
          this.serial_number = '';
        })
        .catch ( (error) => {
          this.$emit('error',  error.message );
        });
    },
  },
  async mounted() {
    this.images = await this.axios.get('/img');
    this.images = this.images.data;
    this.numberOfImages = this.images.length;
    this.index = 0;
    if (this.$route.query.img) {
      const tempIndex = this.images.findIndex( (image) => image.path === this.$route.query.img);
      if (tempIndex >= 0) {
        this.index = tempIndex;
      }
    }
  },
};
</script>